import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'

/**
 * @param {*} WrappedComponent      - inject component
 * @param {string} entityName       - entity name, for ex. event - group - ...
 * @returns {{}}
 */
export function wrapperHighlightPin(WrappedComponent, entityName) {
    return class  WrapperHighlightPin extends Component {
        componentDidMount = () => {
            const node = findDOMNode(this)

            if (node) {
                node.addEventListener('mouseover', this.highlightEntity)
                node.addEventListener('mouseleave', this.removeHighlightEntity)
            }
        }

        componentWillUnmount = () => {
            const node = findDOMNode(this)

            if (node) {
                node.removeEventListener('mouseover', this.highlightEntity)
                node.removeEventListener('mouseleave', this.removeHighlightEntity)
            }
        }

        /**
         * Get entity right name
         *
         * @return {string}
         */
        getEntityName = () => (entityName + (this?.props?.[entityName]?.slug || this?.props?.[entityName]?.id))

        highlightEntity = () => {
            if (this.props.toggleHoverMarker) {
                this.props.toggleHoverMarker(this.getEntityName(), true)
            }
        }

        removeHighlightEntity = () => {
            if (this.props.toggleHoverMarker) {
                this.props.toggleHoverMarker(this.getEntityName(), false)
            }
        }

        render() {
            return (
                <WrappedComponent
                    ref={WrappedComponent.name}
                    {...this.props}
                />
            )
        }
    }
}
